import React from 'react';

import PropTypes from 'prop-types';
import {Button, Segment, Sidebar, Menu, Icon} from 'semantic-ui-react';
import Accordion from 'app-ui-componentlibrary/dist/go/components/common/accordion/Accordion';
import {ContentDispatch} from 'framework';
import _ from 'lodash';

export default class FlyoutPanel extends React.Component {
  static propTypes = {
    /** An array of accordion panels that constitutes a review */
    sections: PropTypes.array.isRequired,

    /** Label for showing the panel */
    showLabel: PropTypes.string,

    /** Label for hiding the panel */
    hideLabel: PropTypes.string,

    /** A function that gets called when "Submit" is clicked */
    handleSubmit: PropTypes.func,

    /** Whether the form is in a "submitting" state (disabled button + loading spinner)*/
    isSubmitting: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    let activeSectionId =
      props.sections && props.sections.length > 0 ? props.sections[0].id : '';
    this.state = {
      activeSection: activeSectionId,
      panelVisibile: true,
    };
  }

  toggleVisibility = (e, d) => {
    this.setState({panelVisibile: !this.state.panelVisibile});
  };

  keyDownToggleVisibility = (e) => {
    if (e.keyCode === 13) {
      this.toggleVisibility();
    }
  };

  handleExpand = (e, {name}) => {
    this.setState({
      activeSection: this.state.activeSection === name ? '' : name,
    });
  };

  renderGlobalFields = () =>
    _.map(this.props.globalFields, (field) => (
      <ContentDispatch
        config={field}
        data={this.props.data}
        dynamicComponent={this.props.dynamicComponent}
        sections={this.props.sections}
      />
    ));

  render() {
    const {
      config,
      data,
      dynamicComponent,
      handleSubmit,
      submitConfig,
      sections,
      globalFields,
    } = this.props;
    const layout = _.get(this.props, 'layout', 'accordion');
    let submitButton = null;
    if (submitConfig) {
      submitButton = (
        <ContentDispatch
          config={submitConfig}
          data={data}
          dynamicComponent={dynamicComponent}
          handleSubmit={handleSubmit}
          disabled={!this.props.isSubmittable}
          size={'large'}
          sections={this.props.sections}
        />
      );
    }

    return (
      <React.Fragment>
        {!this.state.panelVisibile && (
          <Button
            color="grey"
            size="large"
            onClick={this.toggleVisibility}
            onKeyDown={this.keyDownToggleVisibility}
            className="showSidePanel"
          >
            {this.props.showLabel}
          </Button>
        )}
        <Sidebar
          animation="overlay"
          visible={this.state.panelVisibile}
          as={Menu}
          direction="bottom"
          vertical
          id="scoringSidebar"
        >
          <Button
            color="grey"
            size="mini"
            attached="top"
            onClick={this.toggleVisibility}
            onKeyDown={this.keyDownToggleVisibility}
          >
            <Icon name="minus" style={{float: 'left'}} />
            {this.props.hideLabel}
          </Button>
          <div className="contents">
            {layout === 'accordion' ? (
              <Accordion
                sections={this.props.sections}
                activeSection={this.state.activeSection}
                handleExpand={this.handleExpand}
              />
            ) : (
              <React.Fragment>
                {sections &&
                  _.map(sections, (section) => (
                    <React.Fragment>{section.content}</React.Fragment>
                  ))}
              </React.Fragment>
            )}
            {globalFields && (
              <Segment basic textAlign="center">
                {this.renderGlobalFields()}
              </Segment>
            )}
            <Segment basic textAlign="center">
              {submitButton}
            </Segment>
          </div>
        </Sidebar>
      </React.Fragment>
    );
  }
}

FlyoutPanel.defaultProps = {
  isSubmittable: true,
};
